/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgWinchout56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M41.25 6.25V1h8.5v10.5h2.5A2.75 2.75 0 0155 14.25v10A2.75 2.75 0 0152.25 27h-2.5v10.5h-8.5v-5.25h-26.5v5.25h-8.5V27h-2.5A2.75 2.75 0 011 24.25v-10a2.75 2.75 0 012.75-2.75h2.5V1h8.5v5.25h26.5zm7-3.75V36h-5.5V2.5h5.5zm-21 5.25h-5.5v23h5.5v-23zm1.5 0v23h5.5v-23h-5.5zm7 0v23h5.5v-23h-5.5zm-21 0h5.5v23h-5.5v-23zm-1.5-5.25h-5.5V36h5.5V2.5zm39 23h-2.5V13h2.5c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25zM6.25 13h-2.5c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h2.5V13z'
      />
      <path
        fill='currentColor'
        d='M27.254 35v7.508c-3.328.344-6 2.951-6 6.227 0 3.518 3.083 6.265 6.75 6.265 1.994 0 3.799-.804 5.041-2.098a.75.75 0 00-1.082-1.039c-.956.997-2.369 1.637-3.959 1.637-2.96 0-5.25-2.192-5.25-4.765 0-2.574 2.29-4.765 5.25-4.765h.75V35h-1.5z'
      />
    </svg>
  );
}

export default SvgWinchout56;
